import React, { Component } from 'react'
import Api from '../../Api'
import { Config } from '../../Config'
import { CommonConstants } from '../../Constants'

class ValidateAccount extends Component {
  constructor (props) {
    super(props)
    this.state = {
      validation: false,
      message: ''
    }
    this.api = new Api()
  }
  componentWillMount() {
    const params = new URLSearchParams(this.props.history.location.search)
    const uuid = params.get('uuid')
    const url = Config.apiBaseUrl + CommonConstants.apiUrls.accountValidate+'?uuid=' + uuid
    this.api.getData(url, result => {
      if (result.status) {
        this.setState({
          validation: true
        })
      } else {
        this.setState({
          validation: false
        })
      }
    })
  }

  render () {
    return (
      <section className='validateAccount'>
        <div className={'validateAccount ' + (this.state.validation) ? '' : 'hide'}>
          <h3>User Account Activated</h3>
          <p><a className='red_link' href='/'>Click here</a> to login to your account.</p>
        </div>
        <h3 className={'validateAccount ' + (this.state.validation) ? 'hide' : ''}>
          The user record you're trying to activate was not found.
        </h3>
      </section>
    )
  }
}

export default ValidateAccount



// WEBPACK FOOTER //
// ./src/components/Account/validateAccount.js